import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import { format } from "date-fns";
import HeaderSession from "../../../utils/headerSession";
import api from "../../../services/api";
import FazerObservacoes from "../../components/fazerObservacoes.";
import MessageError from "../../../messages/messageError";
import MessageSuccess from "../../../messages/messageSuccess";
// import Loading from "../../../load/loading";
import { useSelector } from "react-redux";
import LoadingShort from "../../../load/loadingShort";
import ObservacoesFeitas from "../../departamentos/dlif/observacoesFeitas";
import DocumentViewer from "../../departamentos/dmts/importacaoExportacao/documentViewer";
import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
import StatusSolicitacoes from "../../../utils/status/statusSolicitacoes";
import InfoFieldGroup from "../../../utils/InfoField/InfoFieldGroup";
import DateHora from "../../../utils/dateHora";
import ProcessoLoading from "../../../load/processoLoading";
// import VerifyPermission from "../../../utils/verifyPermission";

interface Medicamento {
  status: string;
  nome: string;
  numeroRegisto: string;
  dciDosagem: string;
  apresentacao: string;
  areaTerapeutica: string;
  fabricante: string;
  titularAIM: string;
  createdAt: string;
  docs: any[];
  observacoes: any[];
}

const estados = ["Análise", "Aprovado", "Suspenso", "Reprovado", "Cancelado", "Retirado do Mercado"];

const MedicamentoDetalhe: React.FC = () => {
  const user = useSelector((state: any) => state?.account.user);
  const [medicamento, setMedicamento] = useState<Medicamento | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loadStatus, setStatus] = useState(false);
  const [loadObs, setLoadObs] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [obs, setObs] = useState("");
  const [estado, setEstado] = useState("");
  const { id } = useParams();

  useEffect(() => {
    api.get(`/medicamento-aim/${id}`)
      .then((res) => {
        setMedicamento(res.data.medicamentoAIM);
      })
      .catch(() => {});
  }, [refreshPage, id]);

  if (!medicamento) {
    return (
      <div className="tw-text-center">
        <HeaderSession title="DETALHES DO MEDICAMENTO" />
        <ProcessoLoading />
      </div>
    );
  }


  // const coresEstado: Record<string, string> = {
  //   "Análise": "#515151",
  //   "Aprovado": "#2e7d32",
  //   "Suspenso": "#ed6c02",
  //   "Reprovado": "#d32f2f",
  // };


  const handleChangeStatus = () => {
    setError(null);
    setSuccess(null);
    setStatus(true);
    api.patch("/medicamento-aim/change-status", {
      medicamentoAIMId: id,
      status: estado,
      observacao: '',
      userId: user?._id
    })
      .then(() => {
        setSuccess("Estado actualizado!");
        setRefreshPage((prev) => !prev);
        setEstado("");
      })
      .catch((err) => {
        setError(err?.response?.data?.message);
      }).finally(() => setStatus(false));
  };

  const handleObservacao = () => {
    setError(null);
    setSuccess(null);
    setLoadObs(true);
    api.patch("/medicamento-aim/add-observacao", {
      medicamentoAIMId: id,
      content: obs,
      userId: user?._id
    })
      .then(() => {
        setSuccess("Observação adicionada!");
        setRefreshPage((prev) => !prev)
        setObs("");
      })
      .catch((err) => {
        setError(err?.response?.data?.message);
      }).finally(() => setLoadObs(false));
  };

  // temporio para teste de permissões, depois retirar
  const isAuthorized = user?.permissions?.includes('gerenciarEstadoMedicamento') || user?.permissions?.includes('allPermissions');

  return (
    <div className="tw-max-w-[1300px] tw-mx-auto tw-px-4 tw-py-6 tw-flex tw-flex-col tw-gap-6">
      <HeaderSession title="DETALHES DO MEDICAMENTO" />

      <div className="tw-grid tw-gap-6 lg:tw-grid-cols-[300px_minmax(0,1fr)]">
        <aside className="tw-space-y-4">
          <section className="tw-rounded-xl tw-bg-white tw-p-5 tw-shadow-sm tw-border tw-border-slate-200 lg:tw-sticky lg:tw-top-[70px]">
            <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
              <img src="/icones/Medicamentos_autorizados.svg" alt="Medicamento" className="tw-w-[60%]" />
            </div>

            <p className="tw-mt-4 tw-text-center tw-text-slate-700">
              Estado do Medicamento
              <br />
              <strong>{medicamento.status}</strong>
            </p>
          </section>

          {medicamento.observacoes.length > 0 && <ObservacoesFeitas observacoesFeitas={medicamento.observacoes} />}
        </aside>

        <main className="tw-space-y-6 tw-min-w-0">
          {isAuthorized && (
            <section className="tw-rounded-xl tw-bg-white tw-p-5 tw-shadow-sm tw-border tw-border-slate-200">
              <HeaderGestorConfigs title='Gestão de Estado' />

              {error && <MessageError message={error} />}
              {success && <MessageSuccess message={success} />}

              <div className="tw-mt-4 tw-space-y-2">
                <label htmlFor="estado-medicamento" className="tw-block tw-text-sm tw-font-medium tw-text-slate-700">
                  Estado do Medicamento
                </label>
                <select
                  id="estado-medicamento"
                  value={estado}
                  onChange={(e) => setEstado(e.target.value)}
                  className="tw-block tw-w-full tw-rounded-lg tw-border tw-border-slate-300 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-armed-700/30"
                >
                  <option value="" disabled>
                    Selecione o estado
                  </option>
                  {estados.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              {estado && (
                <>
                  <FazerObservacoes
                    setObs={setObs}
                    obs={obs}
                    titulo="(Descreve aqui as observaçōes"
                  />

                  <div className="tw-mt-4 tw-flex tw-flex-wrap tw-justify-end tw-gap-3">
                    <button
                      type="button"
                      onClick={() => {
                        setEstado("");
                        setObs("");
                      }}
                      className="tw-rounded-lg tw-border tw-border-red-500 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-red-600 hover:tw-bg-red-50"
                    >
                      Cancelar
                    </button>

                    <button
                      type="button"
                      disabled={!obs || loadObs || loadStatus}
                      onClick={() => {
                        handleChangeStatus();
                        handleObservacao();
                      }}
                      className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#85287e] tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white disabled:tw-cursor-not-allowed disabled:tw-opacity-60"
                    >
                      {loadObs ? <LoadingShort text={''} /> : "Salvar"}
                    </button>
                  </div>
                </>
              )}
            </section>
          )}

          <section className="tw-rounded-xl tw-bg-white tw-p-5 tw-shadow-sm tw-border tw-border-slate-200">
            <HeaderGestorConfigs title='Informações Gerais' />

            <InfoFieldGroup
              setIsEdit={undefined}
              isEdit={false}
              load={false}
              fields={[
                { label: 'Estado', value: <StatusSolicitacoes status={medicamento?.status} />, key: 'status', onChange: (v) => 'setEditDados({ ...editDados, status: v.target.value })' },
                { label: 'Número de Registo', value: medicamento?.numeroRegisto, key: 'numeroRegisto', onChange: (v) => 'setEditDados({ ...editDados, numeroRegisto: v.target.value })' },
                { label: 'DCI - Dosagem', value: medicamento?.dciDosagem, key: 'dciDosagem', onChange: (v) => 'setEditDados({ ...editDados, dciDosagem: v.target.value })' },
                { label: 'Apresentação', value: medicamento?.apresentacao, key: 'apresentacao', onChange: (v) => 'setEditDados({ ...editDados, apresentacao: v.target.value })' },
                { label: 'Área Terapêutica', value: medicamento?.areaTerapeutica, key: 'areaTerapeutica', onChange: (v) => 'setEditDados({ ...editDados, areaTerapeutica: v.target.value })' },
                { label: 'Fabricante', value: medicamento?.fabricante, key: 'fabricante', onChange: (v) => 'setEditDados({ ...editDados, fabricante: v.target.value })' },
                { label: 'Titular AIM', value: medicamento?.titularAIM, key: 'titularAIM', onChange: (v) => 'setEditDados({ ...editDados, titularAIM: v.target.value })' },
                { label: 'Data de Registo', value: <DateHora date={medicamento?.createdAt} />, key: 'createdAt', onChange: (v) => 'setEditDados({ ...editDados, createdAt: v.target.value })' },
              ]}
            />
          </section>

          {medicamento.docs && (
            <section className="tw-rounded-xl tw-bg-white tw-p-5 tw-shadow-sm tw-border tw-border-slate-200">
              <DocumentViewer urlApi={''} entidade={''} pdfUrls={medicamento.docs as never[]} />
            </section>
          )}
        </main>
      </div>
    </div>

  );
};

export default MedicamentoDetalhe;
